import { useAuth } from "@/contexts/AuthContext";
import { useEarlySatisfaction } from "@/hooks/useEarlySatisfaction";
import UserReviewModal from "@/components/UserReviewModal";

const EarlySatisfactionPopup = () => {
  const { user } = useAuth();
  const { showPopup, dismiss } = useEarlySatisfaction();

  if (!showPopup || !user) return null;

  return (
    <UserReviewModal
      open
      source="early"
      onClose={() => {
        dismiss();
      }}
      onSubmitted={() => {
        dismiss();
      }}
    />
  );
};

export default EarlySatisfactionPopup;
